import UIIllustration from 'UIComponents/image/UIIllustration';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const random = (min, max) => {
  return Math.floor(min + Math.random() * (max - min));
};
export const remain = n => {
  return 100 - n;
};
const getNewCoordinates = () => {
  const r1 = random(15, 75);
  const r2 = random(25, 75);
  const r3 = random(25, 75);
  const r4 = random(25, 75);
  const r11 = remain(r1);
  const r22 = remain(r2);
  const r33 = remain(r3);
  const r44 = remain(r4);
  return `${r1}% ${r11}% ${r22}% ${r2}% / ${r3}% ${r4}% ${r44}% ${r33}%`;
};
const BlobWrapper = styled.div.withConfig({
  displayName: "Blob__BlobWrapper",
  componentId: "sc-18x4zbu-0"
})(["position:relative;opacity:1;width:350px;height:370px;display:flex;align-items:center;justify-content:center;"]);
const BackgroundBlob = styled.div.withConfig({
  displayName: "Blob__BackgroundBlob",
  componentId: "sc-18x4zbu-1"
})(["position:absolute;opacity:1;width:350px;height:370px;display:flex;align-items:center;justify-content:center;background:", ";border-radius:", ";z-index:-2;pointer-events:none;will-change:transform,border-radius;"], ({
  theme
}) => theme.color['fill-accent-yellow-subtle'], getNewCoordinates());
const BackgroundBlobBright = styled.div.withConfig({
  displayName: "Blob__BackgroundBlobBright",
  componentId: "sc-18x4zbu-2"
})(["position:absolute;opacity:1;width:320px;height:320px;display:flex;align-items:center;justify-content:center;background:", ";border-radius:", ";z-index:-1;pointer-events:none;will-change:transform,border-radius;"], ({
  theme
}) => theme.color['fill-accent-yellow-hover'], getNewCoordinates());
const Blob = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(BlobWrapper, {
    children: [/*#__PURE__*/_jsx(BackgroundBlob, {}), /*#__PURE__*/_jsx(BackgroundBlobBright, {}), children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(UIIllustration, {
      name: "account-security",
      width: "40%"
    })]
  });
};
export default Blob;